"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportBatchAddForm = ReportBatchAddForm;
var react_1 = __importStar(require("react"));
var modal_1 = require("../modal");
function ReportBatchAddForm() {
    var _this = this;
    var closeModal = (0, modal_1.useModalClose)();
    var _a = (0, react_1.useState)([]), selectedFiles = _a[0], setSelectedFiles = _a[1];
    var _b = (0, react_1.useState)(""), uploadStatus = _b[0], setUploadStatus = _b[1];
    var handleFileChange = function (event) {
        var files = Array.from(event.target.files || []);
        setSelectedFiles(files);
        setUploadStatus(files.length ? "Selected: ".concat(files.length, " file(s)") : "");
    };
    var handleUpload = function () { return __awaiter(_this, void 0, void 0, function () {
        var formData, _i, selectedFiles_1, file, response, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (selectedFiles.length === 0) {
                        setUploadStatus("Please select a file first.");
                        return [2 /*return*/];
                    }
                    setUploadStatus("Uploading ".concat(selectedFiles.length, " file(s)..."));
                    formData = new FormData();
                    for (_i = 0, selectedFiles_1 = selectedFiles; _i < selectedFiles_1.length; _i++) {
                        file = selectedFiles_1[_i];
                        formData.append("file", file);
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch("/xdh1-api/reports/upload", {
                            method: "POST",
                            body: formData,
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Upload failed");
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    result = _a.sent();
                    if (result.code === 0) {
                        setUploadStatus("\u2713 ".concat(result.message));
                        setSelectedFiles([]);
                        closeModal();
                    }
                    else {
                        setUploadStatus("\u2717 ".concat(result.message));
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    setUploadStatus("\u2717 ".concat(error_1 instanceof Error ? error_1.message : "Unknown error"));
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h2", null, "File Upload"),
        react_1.default.createElement("div", null,
            react_1.default.createElement("input", { type: "file", multiple: true, onChange: handleFileChange })),
        react_1.default.createElement("button", { onClick: handleUpload }, "Upload File"),
        uploadStatus && (react_1.default.createElement("p", { style: { whiteSpace: "pre-line" } }, uploadStatus)),
        react_1.default.createElement("h1", null),
        react_1.default.createElement("small", null, "\u6587\u4EF6\u547D\u540D\uFF1A\u8BA2\u5355\u7F16\u53F7_\u60A3\u8005\u7F16\u53F7.PDF")));
}
